import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPaymentLink, processPaymentLink } from '../services/api';

export default function PaymentPage() {
  const { paymentLinkId } = useParams<{ paymentLinkId: string }>();
  const [link, setLink] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [paid, setPaid] = useState(false);
  const [error, setError] = useState('');
  const [cardForm, setCardForm] = useState({
    cardNumber: '', expiryDate: '', cvv: '', cardHolderName: ''
  });

  useEffect(() => {
    if (!paymentLinkId) return;
    getPaymentLink(paymentLinkId)
      .then(res => { setLink(res.data); setLoading(false); })
      .catch(() => { setError('קישור התשלום לא נמצא'); setLoading(false); });
  }, [paymentLinkId]);

  const handlePay = async () => {
    if (!paymentLinkId) return;
    try {
      await processPaymentLink(paymentLinkId, cardForm);
      setPaid(true);
    } catch {
      setError('התשלום נכשל, אנא נסה שוב');
    }
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5', direction: 'rtl', fontFamily: 'Arial, sans-serif' }}>
      <p>טוען...</p>
    </div>
  );

  if (error && !link) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5', direction: 'rtl', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ background: '#fff', padding: 40, borderRadius: 16, textAlign: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
        <h2>{error}</h2>
      </div>
    </div>
  );

  if (paid || link?.status === 'paid') return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5', direction: 'rtl', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ background: '#fff', padding: 40, borderRadius: 16, textAlign: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>✅</div>
        <h2 style={{ color: '#4CAF50' }}>התשלום בוצע בהצלחה!</h2>
        <p style={{ color: '#666', marginTop: 8 }}>תודה רבה</p>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #7B1FA2 0%, #4A148C 100%)', direction: 'rtl', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ background: '#fff', padding: 32, borderRadius: 16, width: '100%', maxWidth: 450, boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 24, fontWeight: 700, color: '#7B1FA2', marginBottom: 4 }}>MANARA</div>
          <div style={{ fontSize: 13, color: '#999' }}>מכללת מנארה - תשלום מאובטח</div>
        </div>

        <div style={{ background: '#f5f5f5', padding: 16, borderRadius: 8, marginBottom: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ color: '#666' }}>תיאור:</span>
            <span style={{ fontWeight: 600 }}>{link.description || 'תשלום'}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ color: '#666' }}>סכום לתשלום:</span>
            <span style={{ fontWeight: 700, fontSize: 20, color: '#7B1FA2' }}>{link.amount?.toLocaleString()} ₪</span>
          </div>
        </div>

        {error && <div style={{ background: '#ffebee', color: '#c62828', padding: 12, borderRadius: 8, marginBottom: 16 }}>{error}</div>}

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 14 }}>מספר כרטיס</label>
          <input
            style={{ width: '100%', padding: '12px 16px', borderRadius: 8, border: '1px solid #ddd', fontSize: 16, direction: 'ltr', textAlign: 'left', boxSizing: 'border-box' }}
            placeholder="0000 0000 0000 0000"
            value={cardForm.cardNumber}
            onChange={e => setCardForm({...cardForm, cardNumber: e.target.value})}
          />
        </div>
        <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 14 }}>תוקף</label>
            <input
              style={{ width: '100%', padding: '12px 16px', borderRadius: 8, border: '1px solid #ddd', fontSize: 16, direction: 'ltr', textAlign: 'left', boxSizing: 'border-box' }}
              placeholder="MM/YY"
              value={cardForm.expiryDate}
              onChange={e => setCardForm({...cardForm, expiryDate: e.target.value})}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 14 }}>CVV</label>
            <input
              style={{ width: '100%', padding: '12px 16px', borderRadius: 8, border: '1px solid #ddd', fontSize: 16, direction: 'ltr', textAlign: 'left', boxSizing: 'border-box' }}
              placeholder="000"
              type="password"
              maxLength={4}
              value={cardForm.cvv}
              onChange={e => setCardForm({...cardForm, cvv: e.target.value})}
            />
          </div>
        </div>
        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 14 }}>שם בעל הכרטיס</label>
          <input
            style={{ width: '100%', padding: '12px 16px', borderRadius: 8, border: '1px solid #ddd', fontSize: 16, boxSizing: 'border-box' }}
            value={cardForm.cardHolderName}
            onChange={e => setCardForm({...cardForm, cardHolderName: e.target.value})}
          />
        </div>
        <button
          onClick={handlePay}
          disabled={!cardForm.cardNumber || !cardForm.expiryDate || !cardForm.cvv}
          style={{
            width: '100%', padding: '14px', borderRadius: 8, border: 'none',
            background: '#4CAF50', color: '#fff', fontSize: 18, fontWeight: 700,
            cursor: 'pointer', opacity: (!cardForm.cardNumber || !cardForm.expiryDate || !cardForm.cvv) ? 0.5 : 1
          }}
        >
          💳 שלם {link.amount?.toLocaleString()} ₪
        </button>
        <div style={{ textAlign: 'center', marginTop: 16, fontSize: 12, color: '#999' }}>
          🔒 תשלום מאובטח
        </div>
      </div>
    </div>
  );
}
